// import React, { useEffect, useState } from 'react';
// import styled from 'styled-components';
// // import BettingHistory from './bettingHistory';
// import History from './History';

// const BettingTable = ({titlibets}) => {
//   const [activeTab, setActiveTab] = useState('all');

//   const [betData, setBetData] = useState(
//     [
//       { user: "c***5", bet: 8000.00, cashOut: 0 },
//       { user: "w***2", bet: 2000.00, cashOut: 0 },
//       { user: "w***u", bet: 1000.00, cashOut: 0 },
//       { user: "p***8", bet: 1200.00, cashOut: 0 },
//       { user: "s***4", bet: 5000.00, cashOut: 0 },
//       { user: "y***8", bet: 8000.00, cashOut: 0 },
//       { user: "g***1", bet: 9000.00, cashOut: 0 },
//       { user: "w***2", bet: 11000.00, cashOut: 0 },
//       { user: "w***u", bet: 4500.00, cashOut: 0 },
//       { user: "p***8", bet: 9600.00, cashOut: 0 },
//       { user: "s***4", bet: 8500.00, cashOut: 0 },
//       { user: "y***8", bet: 1100.00, cashOut: 0 },
//       { user: "g***1", bet: 7500.00, cashOut: 0 },
//       { user: "w***2", bet: 2300.00, cashOut: 0 },
//       { user: "w***u", bet: 6900.00, cashOut: 0 },
//       { user: "p***8", bet: 6300.00, cashOut: 0 },
//       { user: "s***4", bet: 9800.00, cashOut: 0 },
//       { user: "y***8", bet: 8700.00, cashOut: 0 },
//       { user: "g***1", bet: 9400.00, cashOut: 0 },
//     ]
//   );
//   // Function to update random bet during the game
//   const updateRandomBet = () => {
//     setBetData((prevData) => {
//       const newData = [...prevData];
//       const randomIndex = Math.floor(Math.random() * newData.length); // Random index
//       const randomOutcome = Math.random() < 0.5 ? -1 : 1; // 50% chance of win or loss
//       const randomAmount = Math.floor(Math.random() * 5000) + 1000; // Random amount between 1000 and 6000

//       newData[randomIndex] = {
//         ...newData[randomIndex],
//         cashOut: randomOutcome * randomAmount, // Set random win/loss
//       };

//       return newData;
//     });
//   };
// // console.log(betPlaced)
//   // Trigger random updates while playing
//   useEffect(() => {
//     // if (isPlaying && betPlaced) {
//       const interval = setInterval(() => {
//         updateRandomBet();
//       }, 600); // Update every second

//       return () => clearInterval(interval); // Clear interval when stopped
//     // }
//   }, []);



//   return (
//     <Sidebar>
//       <TabContainer>
//         <Tab active={activeTab === 'all'} onClick={() => setActiveTab('all')}>All Bets</Tab>
//         <Tab active={activeTab === 'my'} onClick={() => setActiveTab('my')}>My Bets</Tab>
//       </TabContainer>

//       {activeTab === 'all' && (
//         <BetList>
//           {betData.map((bet, index) => (
//             <BetItem key={index} color={bet.cashOut > 0 ? 'green' : bet.cashOut < 0 ? 'red' : 'white'}>
//               <div>{bet.user}</div>
//               <div>₹{bet.bet}</div>
//               <div>{bet.cashOut >= 0 ? `₹${bet.cashOut}` : `-₹${Math.abs(bet.cashOut)}`}</div>
//             </BetItem>
//           ))}
//         </BetList>
//       )}
//       {activeTab === 'my' && <History titlibets={titlibets}/> }
//     </Sidebar>
//   );
// };

// const Sidebar = styled.div`
//   width: 30%;
//   background-color: #2b2f3e;
//   border-radius: 16px;
//   padding: 20px;
//   display: flex;
//   height: 90vh;
//   flex-direction: column;
//   box-sizing: border-box;
//   position: fixed;
//   left:  20px;
//   top:150px;
//   @media (max-width: 768px) {
//     width: 100%;
//      position: unset;
//      height: auto;
//        padding: 7px;
//   }
// `;

// const TabContainer = styled.div`
//   display: flex;
//   margin-bottom: 20px;
// `;

// const Tab = styled.button`
//   flex: 1;
//   padding: 10px;
//   background-color: ${(props) => (props.active ? '#28a745' : '#3b3f51')};
//   color: white;
//   border: none;
//   border-radius: 10px;
//   margin-right: 10px;
//   cursor: pointer;
// `;

// const BetList = styled.div`
//   overflow-y: auto;
//   flex: 1;
//  padding:10px 50px;
//   @media (max-width: 768px) {
//    padding:10px 20px;
//   }
// `;

// const BetItem = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 20px;
//   color: ${(props) => props.color};

//    @media (max-width: 768px) {
//    margin-bottom: 50px;
//   }


// `;

// export default BettingTable;




import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const selections = [
  "Butterfly", "Cow", "Football", "Spin", "Flower", "Diya",
  "Bucket", "Kite", "Rat", "Umbrella", "Parrot", "Sun"
];

const randomSelection = () => selections[Math.floor(Math.random() * selections.length)];
// const randomUser = () => {
//   const letter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
//   return `${letter}***${Math.floor(Math.random() * 10)}`;
// };
const randomUser = () => {
  const number = Math.floor(Math.random() * (99 - 5 + 1)) + 5; // range 05–99
  const padded = number.toString().padStart(2, '0'); // ensure 2 digits
  return `C***${padded}`;
};

const randomAvatar = () => `https://randomuser.me/api/portraits/${Math.random() < 0.5 ? 'men' : 'women'}/${Math.floor(Math.random() * 100)}.jpg`;
const betOptions = [10, 20, 50, 100, 500, 1000, 2000, 5000];
const randomBet = () => betOptions[Math.floor(Math.random() * betOptions.length)].toLocaleString('en-IN');


const BettingTable = () => {
  const [bets, setBets] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newBet = {
        avatar: randomAvatar(),
        user: randomUser(),
        bet: randomBet(),
        selection: randomSelection(),
      };

      setBets(prev => {
        const updated = [newBet, ...prev];
        return updated.length > 20 ? updated.slice(0, 20) : updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <Header>
        <span>Total Bets: <Highlight>{bets.length}</Highlight></span>
        <PreviousHand>⟳ Previous hand</PreviousHand>
      </Header>

      <LabelRow>
        <span>User</span>
        <span>Bet</span>
      </LabelRow>

      <List>
        {bets.map((bet, index) => (
          <Item key={index}>
            <UserInfo>
              <Avatar src={bet.avatar} alt="avatar" />
              <MaskedUser>{bet.user}</MaskedUser>
            </UserInfo>
            <Cell>₹{bet.bet}</Cell>
          </Item>
        ))}
      </List>
    </Container>
  );
};

// Styled Components

const Container = styled.div`
  background-color: #1e1f25;
  color: white;
  padding: 20px;
  width: 400px;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 16px;
`;

const Highlight = styled.span`
  color: #28a745;
  font-weight: bold;
`;

const PreviousHand = styled.span`
  color: #aaa;
  font-size: 14px;
  cursor: pointer;
`;

const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  opacity: 0.6;
  font-size: 13px;
  padding: 4px 0;
  border-bottom: 1px solid #333;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

const Item = styled.div`
  background-color: #2c2d34;
  border-radius: 999px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1.5;
`;

const Avatar = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

const MaskedUser = styled.span`
  font-weight: 500;
`;

const Cell = styled.span`
  flex: 1;
  text-align: center;
`;

export default BettingTable;
